import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {makeReactContext} from 'lib/makeReactContext';

import {
  FEATURE_OVERRIDES_FOR_EDITOR_MODE,
  FlowchartEditorMode,
  ProcessFlowchartEditorModeFeatureType,
} from './ProcessFlowchartEditorModeConstants';

export type FlowchartFeatureType =
  | ProcessFlowchartPlatformFeatureType
  | ProcessFlowchartEditorModeFeatureType;

export type FlowchartFeatures = Map<FlowchartFeatureType, boolean>;

export const FlowchartFeaturesContext = makeReactContext<FlowchartFeatures | undefined>(
  () => undefined,
  'FlowchartFeaturesContext'
);

export function getValueForFlowchartFeaturesContext(
  configuratorPlatformFeatures: Map<ProcessFlowchartPlatformFeatureType, boolean>,
  mode: FlowchartEditorMode
): FlowchartFeatures {
  const overrides = FEATURE_OVERRIDES_FOR_EDITOR_MODE[mode];
  const coalescedFeatures = new Map<FlowchartFeatureType, boolean>();

  for (const [feature, value] of configuratorPlatformFeatures) {
    const override = overrides[feature];
    if (override != null) {
      coalescedFeatures.set(feature, override);
    } else {
      coalescedFeatures.set(feature, value);
    }
  }

  for (const modeFeature of Object.values(ProcessFlowchartEditorModeFeatureType)) {
    coalescedFeatures.set(modeFeature, overrides[modeFeature]);
  }

  return coalescedFeatures;
}

export function isFlowchartFeatureEnabled(
  features: FlowchartFeatures | undefined,
  feature: FlowchartFeatureType
): boolean {
  return features?.get(feature) ?? false;
}
